import React, { useState, useEffect, useMemo } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject, GetFieldMes } from '../../../utils/helpers';
import EmisionEjecucionCuotaModal from '../EmisionEjecucionCuotaModal';
import { getDateToString } from '../../../utils/convert';
import { isNull } from '../../../utils/validator';
import CuotaSeleccionModal from '../CuotaSeleccionModal';


const EmisionEjecucionCuotasGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      idEmisionEjecucion: 0,
      disabled: false,
      showMessage: false,
      showCuotaSeleccionModal: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      listCuotas: [],
      listEjecucionCuotas: [],
      listVariables: [],
      listFunciones: [],
      periodo: '',
      fechaVencimiento1: null,
      fechaVencimiento2: null
  });

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    const listEjecucionCuotas = props.data.listEjecucionCuotas.filter(x => x.state !== 'r');
    setState(prevState => {
      return {...prevState,
        idEmisionEjecucion: props.data.idEmisionEjecucion,
        listCuotas: props.data.listCuotas,
        listEjecucionCuotas: listEjecucionCuotas,
        listVariables: props.data.listVariables,
        listFunciones: props.data.listFunciones,
        periodo: props.data.periodo,
        fechaVencimiento1: props.data.fechaVencimiento1,
        fechaVencimiento2: props.data.fechaVencimiento2
      };
    });
  }
  useEffect(mount, [props.data]);

  const allowCuotaSelection = useMemo(() => {
    return state.listCuotas.some(f => !state.listEjecucionCuotas.some(x => x.cuota === f.cuota));
  }, [state.listCuotas, state.listEjecucionCuotas])

  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <>
                                  {!props.modeOnlySelector &&
                                  <div onClick={ (event) => handleClickEmisionEjecucionCuotaAdd1() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                  }
                                  {props.modeOnlySelector && allowCuotaSelection &&
                                  <div onClick={ (event) => handleClickEmisionEjecucionCuotaAdd2() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                  }
                                  </>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickEmisionEjecucionCuotaView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && !props.modeOnlySelector && (
                                  <div onClick={ (event) => handleClickEmisionEjecucionCuotaModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickEmisionEjecucionCuotaRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}                                 
                              </div>

  const tableColumns = [
    { Header: 'Mes', Cell: (props) => {
      const row = props.row.original;
      return GetFieldMes(row.mes, 'name');
    }, id: 'mes', accessor: 'id', width: '12%' },
    { Header: 'Cuota', accessor: 'cuota', width: '12%', disableSortBy: true },
    { Header: '1° Vto.', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaVencimiento1', width: '18%' },
    { Header: '2° Vto.', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaVencimiento2', width: '18%' },
    { Header: 'Descripción', accessor: 'descripcion', width: '30%', disableSortBy: true  },
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
  ];


  //handles
  const handleClickEmisionEjecucionCuotaAdd1 = () => {
    EmisionEjecucionCuotaAdd(0);
  }
  const handleClickEmisionEjecucionCuotaAdd2 = () => {
    setState(prevState => {
      return {...prevState, showCuotaSeleccionModal: true};
    });
  }
  const EmisionEjecucionCuotaAdd = (idEmisionCuota) => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    if (idEmisionCuota > 0) {
      const cuota = state.listCuotas.find(f => f.id === idEmisionCuota);
      const row = {...cuota,
          fechaVencimiento1: new Date(cuota.fechaVencimiento1),
          fechaVencimiento2: new Date(cuota.fechaVencimiento2),
          fechaVencimiento1Original: new Date(cuota.fechaVencimiento1),
          fechaVencimiento2Original: new Date(cuota.fechaVencimiento2),
          id: idTemporal,
          idEmisionEjecucion: 0,
          orden: cuota.cuota,
          state: 'a'
      };
      props.onChange('EmisionEjecucionCuota', row);
    }
    else {
      setState(prevState => {
        const rowForm = {
          id: idTemporal,
          idEmisionEjecucion: state.idEmisionEjecucion,
          cuota: 0,
          mes: 0,
          descripcion: "",
          formulaCondicion: "",
          anioTabla: "",
          mesTabla: 0,
          anioDDJJ: "",
          mesDDJJ: 0,
          fechaVencimiento1: state.fechaVencimiento1,
          fechaVencimiento2: state.fechaVencimiento2,
          fechaVencimiento1Original: state.fechaVencimiento1,
          fechaVencimiento2Original: state.fechaVencimiento2,
          fechaVencimiento1Prorroga: null,
          fechaVencimiento2Prorroga: null,
          orden: 0,
          state: 'a'
        };
        return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
      });
    }
    dispatch( sequenceActionNext() );
  }

  const handleClickEmisionEjecucionCuotaView = (id) => {
    setState(prevState => {
      const rowForm = state.listEjecucionCuotas.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
    });
  }
  const handleClickEmisionEjecucionCuotaModify = (id) => {
    setState(prevState => {
      const rowForm = state.listEjecucionCuotas.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
  }
  const handleClickEmisionEjecucionCuotaRemove = (id) => {
    if (props.requireConfirmRemove) {
      setState(prevState => {
        const rowForm = state.listEjecucionCuotas.find(x => x.id === id);
        return {...prevState, showMessage: true, rowForm: rowForm};
      });
    }
    else {
      const rowForm = state.listEjecucionCuotas.find(x => x.id === id);
      const row = CloneObject(rowForm);
      RemoveEmisionEjecucionCuota(row);
    }
  } 

  //funciones
  function RemoveEmisionEjecucionCuota(row) {
    row.state = 'r';
    props.onChange('EmisionEjecucionCuota', row);
  }

  function UpdateEmisionEjecucionCuota(row) {
    row.state = isNull(state.listEjecucionCuotas.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('EmisionEjecucionCuota', row);
  }

  return (
  <>

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro de borrar el registro?"}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
            }}
            onConfirm={() => {
              const row = CloneObject(state.rowForm);
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
              RemoveEmisionEjecucionCuota(row);
            }}
        />
    }

    {state.showCuotaSeleccionModal &&
        <CuotaSeleccionModal
            data={{
                periodo: state.periodo,
                cuotas: state.listCuotas.filter(f => !state.listEjecucionCuotas.some(x => x.cuota === f.cuota))
            }}
            onConfirm={(idEmisionCuota) => {
              setState(prevState => {
                return {...prevState, showCuotaSeleccionModal: false};
              });
              EmisionEjecucionCuotaAdd(idEmisionCuota);
            }}
            onDismiss={() => {
              setState(prevState => {
                return {...prevState, showCuotaSeleccionModal: false};
              });
            }}
        />
    }

    {state.showForm && 
        <EmisionEjecucionCuotaModal
            disabled={!state.modeFormEdit}
            disabledDates={(state.fechaVencimiento1 && state.fechaVencimiento2)}
            data={{
              entity: state.rowForm,
              listCuotas: state.listCuotas.filter(f => !state.listEjecucionCuotas.some(x => x.cuota === f.cuota)),
              listVariables: state.listVariables,
              listFunciones: state.listFunciones
            }}
            periodo={props.periodo}
            procesaRubros={props.procesaRubros}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
              UpdateEmisionEjecucionCuota(row);
            }}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.listEjecucionCuotas}
    />

  </>
  );
}

EmisionEjecucionCuotasGrid.propTypes = {
  disabled: bool,
  requireConfirmRemove: bool,
  modeOnlySelector: bool,
  data: object.isRequired,
  periodo: string.isRequired,
  procesaRubros: bool.isRequired,
  onChange: func.isRequired
};

EmisionEjecucionCuotasGrid.defaultProps = {
  disabled: false,
  requireConfirmRemove: true,
  modeOnlySelector: false
};

export default EmisionEjecucionCuotasGrid;